/// <reference path="./conf.js" />
/// <reference path="http://api.docodoco.jp/v4/docodoco?key=DzfRAX27Umb1DWNkmbjV6GVLFkPLHwnGWdSlWzqeKmMeXNY9LEAieRF5PzCLKql7" />
'use strict';

/**
 * メイン処理開始
 */
jQuery(document).ready(($)=>
{
	//出発地（トリガーボタン）
	const $buttons = $('.tab-menu li' ,'#main');

	//-----------------------------------------------------
	// 非同期通信のデフォルト設定
	const Ajax = {
		load: function( _param )
		{
			return new Promise( function( _resolve, _reject )
			{
				//Ajax送信処理を記述
				let option = {
					url		: 'Set URL !!'
					,type		: 'GET'
					,dataType	: 'jsonp'	//text,html,xml,script,json,jsonpのいずれか
					,crossDomain: true
					,scriptCharset: 'UTF-8'
					,cache		: false
					,timeout	: 8000
					,username	: ''
					,password	: ''
					,processData: true		//自動エンコード
					,beforeSend : $.noop
					,success: _resolve
					,error: _reject
				};

				//パラメータをマージして送信
				$.ajax( _.merge( {}, option, _param ) );
			});
		}
	};

	/**
	 * 位置情報取得
	 */
	function getDepAreaByIP()
	{
		try {
			if(SURFPOINT.getPrefCode() <= 22)
				return CONST.dep.東京;
			else if (SURFPOINT.getPrefCode() <= 39)
				return CONST.dep.関西;
			else
				return CONST.dep.九州; //九州デフォルト
		} catch (err) {
			return CONST.dep.九州; //九州デフォルト
		}
	}

	/**
	 * タブidから出発地idを取得
	 */
	function getDepareaByTabid( _tab_id = 1 )
	{
		const deps = [null, CONST.dep.九州, CONST.dep.東京, CONST.dep.関西];
		return deps[ _tab_id ];
	}

	//-----------------------------------------------------
	// クリックイベント登録
	$buttons.on('click', function(evt)
	{
		$buttons.removeClass('current');
		$(`table.tab-content`).removeClass('current');

		//押されたボタンのtab_idを取得
		const tab_id = $(evt.currentTarget).addClass('current').data('tab-id');
		const depcity = getDepareaByTabid(tab_id);
		const $table = $(`table[data-tab-id="${tab_id}"].tab-content`).addClass('current');

		if( $table.data('loaded') ) return false;

		//データ取得準備
		const options = {
			url : CONFIG.url.api,
			type : 'GET',
			data : {
				disppattern : 4,
				depcity : depcity
			},
		};
		//-----------------------------------------------------
		//取得開始
		Ajax.load( options )
			.then(( _json )=>
			{
				const $tr = $( 'tbody', $table);
				//htmlにデータ投入
				$.each( _json, function(key, data)
				{
					const $row = $( `tr[data-yosan="${key}"]`, $tr );

					$.each( data, function(tdindex, item)
					{
						var $td = $('td', $row).eq( tdindex - 2 ); //TDの位置を求めるマジックナンバー
						var $tag = $('<a></a>').attr('href', item.link ).html( item.count );
						$td.html($tag);
					});
				});

				return _json;
			})
			.then(()=>
			{
				$table.data('loaded', true);
			})
			;
		return false;
	})
	.eq(0)
	.trigger('click')
	;
	
});